import angular from 'angular'

/**
 * REMOVING COMPONENTS
 * -------------------
 *
 * If you remove a component from this file, please check the associated styles in
 * Helios. It could be that the styles are no longer needed and can be removed.
 *
 * See https://github.com/lightspeed/helios/tree/main/packages/helios-css
 */
import './vd-action-bar/vd-action-bar'
import './vd-autocomplete/vd-autocomplete'
import './vd-avatar-multi/vd-avatar-multi'
import './vd-badges/vd-badges'
import './vd-carousel/vd-carousel'
import './vd-dialog/vd-dialog'
import './vd-dialog-close/vd-dialog-close'
import './vd-dialog-drawer/vd-dialog-drawer'
import './vd-dott/vd-dott'
import './vd-dropdown/vd-dropdown'
import './vd-expandable/vd-expandable'
import './vd-expandable/vd-expandable-content'
import './vd-expandable/vd-expandable-trigger'
import './vd-feedback/vd-feedback'
import './vd-flex/vd-flex'
import './vd-focus/vd-focus'
import './vd-focustrap/vd-focustrap'
import './vd-header/vd-header'
import './vd-icon/vd-icon'
import './vd-in-page-help/vd-in-page-help'
import './vd-nav-item/vd-nav-item'
import './vd-no-widow/vd-no-widow'
import './vd-panel/vd-panel'
import './vd-popover/vd-popover'
import './vd-promo/vd-promo'
import './vd-section/vd-section'
import './vd-section-back/vd-section-back'
import './vd-select-input/vd-select-input'
import './vd-sidebar/vd-sidebar'
import './vd-sidebar-drawer/vd-sidebar-drawer'
import './vd-sidebar-tabs/vd-sidebar-tabs'
import './vd-splash/vd-splash'
import './vd-suggestion/vd-suggestion'
import './vd-tabs/vd-tab'
import './vd-tabs/vd-tabs'
import './vd-tag-input/vd-tag-input'
import './vd-toast-notification/vd-toast-notification'
import './vd-tooltip/vd-tooltip'
import './vd-topbar/vd-topbar'
import './vd-tracking/vd-track-links'

// Angular 1.5+ Components
import AutocompleteFilterComponent from './vd-autocomplete-filter/vd-autocomplete-filter.component'
import BannerComponent from './vd-banner/vd-banner.component'
import CheckboxComponent from './vd-checkbox/vd-checkbox.component'
import DateFromNowComponent from './vd-date-from-now/vd-date-from-now.component'
import ErrorMessageComponent from './vd-error-message/vd-error-message.component'
import ExpandableChevron from './vd-expandable/vd-expandable-chevron.component'
import FlagComponent from './vd-flag/vd-flag.component'
import LoadMore from './vd-load-more/vd-load-more.component'
import LozengeComponent from './vd-lozenge/vd-lozenge.component'
import MultiselectPopoverComponent from './vd-multiselect-popover/vd-multiselect-popover.component'
import NextStepperComponent from './vd-next-stepper/vd-next-stepper.component'
import RadioComponent from './vd-radio/vd-radio.component'
import RadioGroupComponent from './vd-radio/vd-radio-group.component'
import SaveComponent from './vd-save/vd-save.component'
import ScrollableComponent from './vd-scrollable/vd-scrollable.component'
import Segcontrol from './vd-segcontrol/vd-segcontrol.component'
import SegcontrolGroup from './vd-segcontrol/vd-segcontrol-group.component'
import SwitchComponent from './vd-switch/vd-switch.component'
import VdAvatar from './vd-avatar/vd-avatar.component'
import UpsellPrimaryComponent from './vd-upsell-primary/vd-upsell-primary.component'
import UpsellSecondaryComponent from './vd-upsell-secondary/vd-upsell-secondary.component'
import VdBgImageDirective from './vd-bg-image/vd-bg-image.directive'
import VdClickSelectDirective from './vd-click-select/vd-click-select.directive'
import VdDateDirective from './vd-date/vd-date.directive'
import VdInputCharLimit from './vd-input-char-limit/vd-input-char-limit.directive'
import VdInputSymbol from './vd-input-symbol/vd-input-symbol.directive'
import VdLazyLoadDirective from './vd-lazy-load/vd-lazy-load.directive'
import VdTextarea from './vd-textarea/vd-textarea.directive'

angular
  .module('vend.ui')
  .component('vdAutocompleteFilter', AutocompleteFilterComponent)
  .component('vdAvatar', VdAvatar)
  .component('vdBanner', BannerComponent)
  .component('vdCheckbox', CheckboxComponent)
  .component('vdDateFromNow', DateFromNowComponent)
  .component('vdErrorMessage', ErrorMessageComponent)
  .component('vdExpandableChevron', ExpandableChevron)
  .component('vdFlag', FlagComponent)
  .component('vdLoadMore', LoadMore)
  .component('vdLozenge', LozengeComponent)
  .component('vdMultiselectPopover', MultiselectPopoverComponent)
  .component('vdNextStepper', NextStepperComponent)
  .component('vdRadio', RadioComponent)
  .component('vdRadioGroup', RadioGroupComponent)
  .component('vdSave', SaveComponent)
  .component('vdSegcontrol', Segcontrol)
  .component('vdSegcontrolGroup', SegcontrolGroup)
  .component('vdScrollable', ScrollableComponent)
  .component('vdSwitch', SwitchComponent)
  .component('vdUpsellPrimary', UpsellPrimaryComponent)
  .component('vdUpsellSecondary', UpsellSecondaryComponent)
  .directive('vdBgImage', VdBgImageDirective)
  .directive('vdClickSelect', VdClickSelectDirective)
  .directive('vdDate', VdDateDirective)
  .directive('vdInputCharLimit', VdInputCharLimit)
  .directive('vdInputSymbol', () => new VdInputSymbol())
  .directive('vdLazyLoad', VdLazyLoadDirective)
  .directive('vdTextarea', VdTextarea)
